var module = angular.module('octopusApp.users');

module.controller('SignOutController', function ($scope, $rootScope, $location,$state, octopusLog, octopusRepository, octopusAuthenticator, octopusFeatures,  busy, $window) {
    var isSubmitting = $scope.isSubmitting = busy.create();

    $scope.signOut = function() {
        octopusLog.log("Attempting to sign out");
        isSubmitting.promise(octopusRepository.Users.signOut()
      .then(function () {
          octopusAuthenticator.setCurrentPrincipal(null, null);
          $rootScope.redirectAfterFormsLoginTo = null;
          $rootScope.redirectAfterExternalLoginTo = null;
          octopusFeatures.refresh();
          octopusLog.log("Sign out successful, redirecting");
          //$location.path("/");
          $state.go('app');
      }));
    };

    $scope.cancel = function () {
        $window.history.back();
    };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/users/controllers/sign_out_controller.js
// module id = 644
// module chunks = 1